import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { HiMenuAlt3, HiX } from "react-icons/hi";
import "./topbar.css";

const navigation = [
    { path: "/", label: "Home", exact: true },
    { path: "/praktijk", label: "Praktijk" },
    { path: "/consult", label: "Consult" },
    { path: "/tips", label: "Tips" },
    { path: "/adres", label: "Locaties" },
];

export default function Topbar() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setMenuOpen(false);
    }, [location.pathname]);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll);

        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header className={`topbar ${scrolled ? "topbar--scrolled" : ""}`}>
            <div className="topbar__inner">
                <Link className="topbar__brand" to="/">
                    <img
                        className="topbar__logo"
                        src={require("../../static/afbeeldingen/Final-Logo-01.png")}
                        alt="Logo van Vandaag Begin Ik"
                    />
                    <div className="topbar__brand-copy">
                        <span className="topbar__eyebrow">Leefstijl- en diëtistenpraktijk</span>
                        <span className="topbar__title">Vandaag Begin Ik</span>
                        <span className="topbar__subtitle">Rita Wilschut in Breda</span>
                    </div>
                </Link>

                <button
                    type="button"
                    className="topbar__toggle"
                    onClick={() => setMenuOpen((current) => !current)}
                    aria-expanded={menuOpen}
                    aria-label={menuOpen ? "Menu sluiten" : "Menu openen"}
                >
                    {menuOpen ? <HiX /> : <HiMenuAlt3 />}
                </button>

                <nav className={`topbar__nav ${menuOpen ? "topbar__nav--open" : ""}`}>
                    {navigation.map((item) => (
                        <NavLink
                            key={item.path}
                            exact={item.exact}
                            to={item.path}
                            className="topbar__link"
                            activeClassName="topbar__link--active"
                        >
                            {item.label}
                        </NavLink>
                    ))}
                    <Link className="topbar__cta" to="/contact">
                        Plan contact
                    </Link>
                </nav>
            </div>
        </header>
    );
}
